import { render, staticRenderFns } from "./DeviceGroup.vue?vue&type=template&id=2d0796cd"
import script from "./DeviceGroup.vue?vue&type=script&lang=ts"
export * from "./DeviceGroup.vue?vue&type=script&lang=ts"
import style0 from "./DeviceGroup.vue?vue&type=style&index=0&id=2d0796cd&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports